import { render, staticRenderFns } from "./AddDoner.vue?vue&type=template&id=18dab614"
import script from "./AddDoner.vue?vue&type=script&lang=js"
export * from "./AddDoner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports